<template>
    <div>
        <Dialog v-bind:value="value" @input="$emit('input', $event)"
                :title="details ? 'Publisher bearbeiten' : 'Neuen Publisher anlegen'"
                :loading="loading"
                :okDisabled="loadingTargetings"
                width="500"
                @click:outside="close"
                @ok="submit"
                @cancel="close"
        >
            <template v-slot:button v-if="details">
                <Button :text="true" :color="ada.red" v-if="!$store.state.readOnly"
                        :disabled="loadingTargetings"
                        @click="showDeleteDialog = true">
                    Löschen
                </Button>
            </template>
            <v-row>
                <v-col cols="12">
                    <Input :hide-details="true" v-model.trim="name" label="Bezeichnung"></Input>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <div class="d-flex align-center">
                        <Dropdown
                            v-model="targetings"
                            :items="$store.state.settings.targetings"
                            item-text="Name" item-value="TargetingId"
                            label="Targetings"
                            :multiple="true"
                            :loading="loadingTargetings"
                            hide-details="auto"
                        />
                        <TooltipIcon tooltip="Neues Targeting hinzufügen"
                                     @click="showAddTargetingDialog = true">mdi-plus-box-multiple
                        </TooltipIcon>
                    </div>
                </v-col>
            </v-row>
        </Dialog>
        <AddEditTargetingDialog v-model="showAddTargetingDialog" :addOnly="true"></AddEditTargetingDialog>
        <DeletePublisherDialog v-model="showDeleteDialog" @deleted="close"></DeletePublisherDialog>
    </div>
</template>

<script>
import Dialog from "../../../components/Dialog";
import Input from "../../../components/Inputs/Input";
import Button from "../../../components/buttons/Button";
import ada from "../../../scss/ada_colors.scss";
import DeletePublisherDialog from "./DeletePublisherDialog";
import Dropdown from "../../../components/Inputs/Dropdown";
import TooltipIcon from "../../../components/TooltipIcon";
import AddEditTargetingDialog from "./AddEditTargetingDialog";

export default {
    name: "AddEditPublisherDialog",
    props: ['value'],
    components: {AddEditTargetingDialog, TooltipIcon, Dropdown, DeletePublisherDialog, Button, Input, Dialog},
    data: () => {
        return {
            name: null,
            loading: false,
            loadingTargetings: false,
            showDeleteDialog: false,
            showAddTargetingDialog: false,
            targetings: [],
            ada
        }
    },
    mounted() {
        this.init();
    },
    computed: {
        details() {
            return this.$store.state.settings.selectedDetails;
        },
    },
    methods: {
        async init() {
            if (this.details) {
                this.name = this.details.Name;
                if (this.details.PublisherId) {
                    this.loadingTargetings = true;
                    await this.$store.dispatch('settings/fetchTargetingListByPublisherId', this.details.PublisherId);
                    this.targetings = this.$store.state.settings.targetingsByPublisher;
                    this.loadingTargetings = false;
                }
            } else {
                this.name = null;
                this.targetings = null;
                this.$store.commit('settings/updateTargetingsByPublisher', []);
            }
        }
        ,
        async submit() {
            this.loading = true;
            try {
                let data = await this.$store.dispatch('settings/editPublisher', this.getBody());
                this.loading = false;
                if (data.Status) {
                    let msg = this.details ? 'Erfolgreich gespeichert.' : 'Publisher erfolgreich angelegt.';
                    this.$root.$emit('snackbar', msg);
                    this.close();
                }
            } catch (e) {
                this.loading = false;
            }
        },
        getBody() {
            let json = {
                Name: this.name,
                targeting_ids: this.targetings.map(x => x.TargetingId),
            };
            if (this.details) json.publisher_id = this.details.PublisherId;
            return json;
        },
        close() {
            this.$store.commit('settings/resetSelected');
            this.init();
            this.$emit('input', false); // set v-model to false -> close dialog
        },
    }
    ,
    watch: {
        details() {
            if (this.$store.state.settings.activeTab === 'Settings_Publisher') this.init();
        }
    }
}
</script>

<style lang="scss" scoped>
</style>